import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import * as moment from 'moment';
import { ViewMode } from '../calendar/calendar.component';

export interface DateRange {
    start?: moment.Moment;
    end?: moment.Moment;
}

@Component({
    selector: 'ui-date-range',
    template: require('./ui-date-range.component.html'),
    styles: [require('./ui-date-range.component.less')],
})
export class UiDateRangeComponent implements OnInit, OnChanges {
    @Input() range: DateRange = <DateRange> {};
    @Output() rangeChange = new EventEmitter<DateRange>();

    currentViewMode: ViewMode = ViewMode.month;
    leftStartDate: moment.Moment;
    rightStartDate: moment.Moment;
    hoveredDay?: moment.Moment;
    hoveredMonth?: moment.Moment;
    private originalRange = <DateRange> {};

    ngOnInit(): void {
        this.setStartDate(moment());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.range && changes.range.currentValue) {
            const newRange = changes.range.currentValue;
            this.range = newRange.start && newRange.end ? { ...newRange } : <DateRange> {};
        }
    }

    onInsideMenuClick($event: MouseEvent): void {
        $event.stopPropagation();
    }

    onLeftBtnClicked(): void {
        this.setStartDate(this.leftStartDate.clone().add(-1, this.currentViewMode));
    }

    onRightBtnClicked(): void {
        this.setStartDate(this.leftStartDate.clone().add(1, this.currentViewMode));
    }

    onLeftStartDateChanged(date: moment.Moment): void {
        this.setStartDate(date);
    }

    onRightStartDateChanged(date: moment.Moment): void {
        this.setStartDate(date.add(-1, this.currentViewMode));
    }

    isSelected(date: moment.Moment, unit: moment.unitOfTime.StartOf): boolean {
        return this.isSameDay(date, this.range.start, unit) || this.isSameDay(date, this.range.end, unit);
    }

    onDayClicked(date: moment.Moment): void {
        if ((this.range.start && this.range.end) || (!this.range.start && !this.range.end)) {
            this.range.start = date;
            this.range.end = undefined;
        } else {
            if (date.isBefore(this.range.start, 'day')) {
                this.range.start = date;
            } else {
                this.range.end = date;
                this.emitRangeChange();
            }
        }
    }

    isBetweenSelection(
        date: moment.Moment,
        hoveredDate: moment.Moment,
        unit: moment.unitOfTime.StartOf,
    ): boolean {
        if (this.range.start && this.range.end) {
            return date.isAfter(this.range.start, unit) && date.isBefore(this.range.end, unit);
        }
        if (hoveredDate && this.range.start && !this.range.end) {
            return date.isAfter(this.range.start, unit) && date.isSameOrBefore(hoveredDate, unit);
        }
        return false;
    }

    private emitRangeChange(): void {
        if (this.isEqualRanges(this.originalRange, this.range)) {
            return;
        }
        this.originalRange = { ...this.range };
        this.rangeChange.emit({ ...this.range });
    }

    private isEqualRanges(r1: DateRange, r2: DateRange): boolean {
        return this.isSameDay(r1.start, r2.start, 'day') &&
            this.isSameDay(r1.end, r2.end, 'day');
    }

    private isSameDay(
        d1: moment.Moment | undefined,
        d2: moment.Moment | undefined,
        unit: moment.unitOfTime.StartOf,
    ): boolean {
        return (!d1 && !d2) || (d1 && d2 && d1.isSame(d2, unit)) ? true : false;
    }

    private setStartDate(date: moment.Moment): void {
        this.leftStartDate = date;
        this.rightStartDate = date.clone().add(1, this.currentViewMode);
    }

    private setPeriod(days) {
        this.range.end = moment();
        this.range.start = this.range.end.clone().add(-days + 1, 'day');
        this.setStartDate(this.range.start);
        this.emitRangeChange();
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/calendar/ui-date-range/ui-date-range.component.ts